import { useQuery } from '@tanstack/react-query';
import { usersApi } from '@/lib/apiClient';
import { useAuth } from '@/contexts/AuthContext';

export const useCurrentUser = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['current-user', user?.email],
    queryFn: async () => {
      if (!user?.email) {
        throw new Error('Utilisateur non connecté');
      }

      const currentUser = await usersApi.getUserByEmailUsersByEmailEmailGet(user.email);
      if (!currentUser || typeof currentUser.id !== 'number') {
        throw new Error("Utilisateur non trouvé pour cet email");
      }

      return currentUser;
    },
    enabled: !!user?.email,
    staleTime: 5 * 60 * 1000, // 5 minutes - le cache sera utilisé pendant 5 min
    gcTime: 10 * 60 * 1000, // 10 minutes - les données restent en cache 10 min
  });
};

